var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"value":_vm.selectedid,"items":_vm.devices,"multiple":false,"chips":false,"small-chips":false,"deletable-chips":false,"item-text":item => item.name ? item.name.slice(0, 30) : `name`,"item-value":"id","label":_vm.$trans('monitor.device'),"single-line":true,"rules":_vm.devicesRule},on:{"change":_vm.emitInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }